<template>
    <Splide v-if="news.length" :options="splideOptions">
        <SplideSlide
            v-for="i in news"
            :key="i.id">
            <NewsCard :news="i" />
        </SplideSlide>
    </Splide>
</template>

<script setup lang="ts">
    import { Splide, SplideSlide } from '@splidejs/vue-splide';
    import NewsCard from './NewsCard.vue';

    const props = defineProps<{
        news: any[];
    }>();

    const splideOptions = ref({
        type: 'slide',
        perPage: 3,
        perMove: 1,
        gap: '4rem',
        pagination: false,
        arrows: props.news.length > 3,
        autoplay: props.news.length > 3,
        interval: 2000,
        rewind: true,
        breakpoints: {
            1279: {
                gap: '1rem',
                perPage: 2,
            },
            640: {
                perPage: 1,
                gap: '1rem',
                arrows: props.news.length > 1,
                autoplay: props.news.length > 1,
            },
        },
    });
</script>

<style scoped></style>
